import {Participant} from '../models/participant';

export function formatParticipantName(participant: Participant): string {
    if (participant.laneNumber !== null && participant.laneNumber !== undefined) {
        return `Lane ${participant.laneNumber} - ${participant.name}`;
    }
    return participant.name;
}
